module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auth-services"
  }, [_c('div', [(_vm.isEsiaModule) ? _c('EsiaLink', {
    staticClass: "auth-services_btn"
  }) : _vm._e()], 1), _vm._v(_vm._s(_vm.errMsg))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17f09f88","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/default/popup/forms/authServices/AuthServices.vue
// module id = 84924e6af773117d1ac0
// module chunks = 89